/**
 * ForecastBand — Ay sonu net kâr projeksiyonu bandı.
 *
 * Saf matematik (linear extrapolation, std dev). AI çıkarım yok.
 *
 * Props:
 *   forecast: forecast_service.ay_sonu_projeksiyon output (None ise gizli)
 */
import React from 'react';
import { useTheme } from '../../styles/ThemeProvider';
import { formatTRY } from '../../utils/analytics/format';

export default function ForecastBand({ forecast }) {
  const { theme } = useTheme();

  if (!forecast) {
    return null; // Veri yetersiz → gösterme
  }

  const { ay_sonu_tahmin_tl, p25_tl, p75_tl, kalan_gun, gunluk_ortalama_tl } = forecast;

  return (
    <section style={{
      background: theme.color.surface,
      padding: theme.space.lg,
      borderRadius: theme.radius.md,
      border: `1px solid ${theme.color.border}`,
      borderLeft: `4px solid #0d6efd`,
    }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: theme.space.md, flexWrap: 'wrap' }}>
        <div>
          <div style={{ fontSize: 11, color: theme.color.textSoft, textTransform: 'uppercase', letterSpacing: 0.5 }}>
            Ay Sonu Projeksiyonu (Net Kâr)
          </div>
          <div style={{ fontSize: 28, fontWeight: 700, color: ay_sonu_tahmin_tl < 0 ? theme.color.danger : theme.color.text }}>
            {formatTRY(ay_sonu_tahmin_tl, { decimals: 0 })}
          </div>
        </div>

        <div style={{ fontSize: 13, color: theme.color.textSoft, marginLeft: 'auto' }}>
          <div>Aralık: <span style={{ fontFamily: 'monospace', color: theme.color.text }}>{formatTRY(p25_tl, { decimals: 0 })} — {formatTRY(p75_tl, { decimals: 0 })}</span></div>
          <div>Günlük ort: <span style={{ fontFamily: 'monospace' }}>{formatTRY(gunluk_ortalama_tl, { decimals: 0 })}</span> · Kalan gün: <strong>{kalan_gun}</strong></div>
        </div>
      </div>

      <div style={{ marginTop: 8, fontSize: 11, color: theme.color.textSoft }}>
        Yöntem: Son 30 günün ortalaması × kalan ay günü (linear extrapolation). Aralık ±0.67σ.
      </div>
    </section>
  );
}
